import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "contrast-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "currentColor", d: "M8.5 1a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15zm0 1.5v12a6 6 0 1 0 0-12z" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
